__webpack_require__.p = "/reports-action-response-notifications/referrals-hub/";